import React from "react";

const StatCard = ({ label, value, subLabel, valueColor }) => (
  <div className="bg-white border border-gray-200 rounded-xl p-5 flex flex-col gap-1">
    <span className="text-[11px] font-semibold text-gray-400 tracking-widest uppercase">
      {label}
    </span>
    <span className={`text-2xl font-bold ${valueColor || "text-gray-900"}`}>
      {value}
    </span>
    {subLabel && (
      <span className="text-xs text-gray-400">{subLabel}</span>
    )}
  </div>
);

export default StatCard;
